import React, { useEffect, useRef, useState } from 'react';
import './index.less';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Menus from '@/components/Menus';
import { MenuItem } from '@/types/base';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn';
import { AI_MENU, BASE_PERMISSION_CODE, FAE_MENU, MENU_PERMISSION_LIST } from './config';
import { getPermission } from '@/api/technical';
import { goLogin } from '@/utils/common';

dayjs.locale('zh-cn');

const prefix = 'technical-support';
const TechnicalSupport: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = useRef<any>(null);
  const permissionRef = useRef<any>(null);
  const selectMenuId = useRef<any>('');
  const [menuList, setMenuList] = useState<MenuItem[]>([
    {
      id: 'notice',
      key: '1',
      title: '通知公告',
      children: [],
      pagePath: ['/technicalSupport/notice', '/technicalSupport/noticeDetail'],
      iconUrl: require('@/assets/images/support/notice.png')
    },
    {
      id: 'feedback',
      key: '2',
      title: '问题反馈',
      children: [],
      pagePath: ['/technicalSupport/feedback', '/technicalSupport/feedbackDetail'],
      iconUrl: require('@/assets/images/support/feedback.png')
    },
    {
      id: 'faq',
      key: '3',
      title: '常见Q&A',
      children: [],
      pagePath: ['/technicalSupport/faq', '/technicalSupport/faqDetail'],
      iconUrl: require('@/assets/images/support/faq.png')
    },
    {
      id: 'certificate',
      key: '4',
      title: '证书查询/下载',
      children: [],
      pagePath: ['/technicalSupport/certificate'],
      iconUrl: require('@/assets/images/support/certificate.png')
    }
  ]);

  /**
   * 递归查找菜单
   * @param menu 
   */
  const findMenu = (menus: MenuItem[]) => {
    let currentMenu: any = null;
    for (let i = 0; i < menus.length; i++) {
      const item = menus[i];
      if (item.children && item.children.length > 0) {
        currentMenu = findMenu(item.children);
      } else {
        const hasMenu = Array.isArray(item.pagePath) ? item.pagePath.find(v => currentPath.current?.includes(v)) : item.pagePath === currentPath.current;
        if (hasMenu) {
          currentMenu = item;
        }
      }
      if (currentMenu) break;
    }
    return currentMenu;
  }

  if (location.pathname !== currentPath.current) {
    currentPath.current = location.pathname;
  }
  const menu = findMenu(menuList);
  console.log('menu', menu, currentPath.current);
  //是否匹配到菜单
  if (menu) {
    selectMenuId.current = menu.id;

  } else {
    selectMenuId.current = '';
    if (permissionRef.current) {
      setTimeout(() => {
        window?.message.warning('您没有权限访问该页面');
      }, 0);
    }
  }

  const menuClick = (data: any) => {
    console.log('menuClick', data);
    if (data.pagePath == currentPath.current) return;
    const path = Array.isArray(data.pagePath) ? data.pagePath[0] : data.pagePath;
    navigate(path);
  }


  /**
   * 获取菜单权限
   */
  const getMenuPermission = () => {
    getPermission().then((res: any) => {
      console.log('getUserDetail', res);
      if (res?.code == 200) {
        const permissions = res?.data?.permissions;
        if (Array.isArray(permissions)) {
          const menuCopy = [...menuList];
          const technicalPermission = permissions.filter((item: any) => item.includes(BASE_PERMISSION_CODE));
          if (technicalPermission) {
            MENU_PERMISSION_LIST.forEach((child: any) => {
              let isMenu=false;
              technicalPermission.forEach((item: any) => {
                const list = item.split('-');
                if (list.find((e: any) => e == child.code)) {
                    isMenu=true;
                }
              })
              isMenu&& menuCopy.push(child.menu);
            })
            setMenuList([...menuCopy]);
          }
          permissionRef.current = technicalPermission;
        }
      }
      //问答模块无需登录
      if (res?.code == 401 && !(menuList.some((v: any) => v.pagePath.find((v: any) => currentPath.current?.includes(v))))) {
        goLogin();
      }

    }).catch((err: any) => {
      console.error('getUserDetail err', err);
    })
  }

  useEffect(() => {
    getMenuPermission();
  }, [])
  return (
    <div className={prefix}>
      <div className={prefix + '-aside'}>
        <Menus
          menuList={menuList}
          selectMenuId={selectMenuId.current}
          onMenuClick={menuClick}
        />
      </div>
      <div className={prefix + '-main'}>
        {
          selectMenuId.current !== '' && <ConfigProvider locale={zhCN}>
            <Outlet />
          </ConfigProvider>
        }
      </div>

    </div>
  );
};

export default TechnicalSupport;
